import { TextboxField } from './textbox';
import { DropdownField } from './dropdown';
import { FlatSelectField } from './flat-select';
import { JamboFlatSelectField } from './jambo-flat-select';
import { FlatSelectImgOnlyField } from './flat-select-img-only';
import { FlatImageGalleryField } from './flat-image-gallery';
import { DateField } from './date';
import { FieldControl } from '@signature-it/ngx-generic/enums';
import { RadioButtonField } from './radio-button';
import { CurrencyField } from './currency';
import { SeparatorField } from './separator';
import { SignatureField } from './signature';
import { FileUploadField } from './file-upload';
import { GridField } from './grid';
import { BarCode } from './BarCode';
import { MultiSelectGroupsField } from './multi-select-groups';
import { StarRatingField } from './star-rating';
import { CaptchaField } from './captcha';
import { NumberRatingField } from './number-rating';
import { PercentageField } from './percentage';
import { NgxComponentField } from './ngx-component';
import { CheckboxField } from './checkbox';
import { SlideToggleField } from './SlideToggle';
import { TextareaField } from './textarea';
import { ConfirmationField } from './confirmation-field';
import { CardValidity } from './card-validity';
import { PhoneWithPrefix } from './phone-with-prefix';
import {UsersAutocomplete} from "./users-autocomplete";
import {Autocomplete} from"./autocomplete";
import {LookUpDetailField} from "./look-up-detail";
import {LookUpField} from "./look-up";
import {UserLookUpField} from "./user-look-up";
import {UserLookUpDetailField} from "./user-look-up-detail";

declare let _: any;

// @dynamic
export class FormFieldFactory {

    public static create(attributes: object) {
        if ( !attributes['controlType'] && attributes['type'] ) {
            attributes['controlType'] = attributes['type'].replace(/ /g, '');
        }
        switch (attributes['controlType']) {
            case FieldControl.DROPDOWN:
                return new DropdownField(attributes);
            case FieldControl.DROPDOWN_WITH_IMG:
				attributes['withImages'] = true;
				return new DropdownField(attributes);
            case FieldControl.FLAT_SELECT:
				return new FlatSelectField(attributes);
            case FieldControl.JAMBO_FLAT_SELECT:
                return new JamboFlatSelectField(attributes);
			case FieldControl.FLAT_SELECT_WITH_IMG:
				attributes['withImages'] = true;
				return new FlatSelectField(attributes);
			case FieldControl.FLAT_SELECT_WITH_HOVER_IMG:
				attributes['withImages'] = true;
				attributes['withHoverImages'] = true;
				return new FlatSelectField(attributes);
            case FieldControl.FLAT_SELECT_IMG_ONLY:
                attributes['withImages'] = true;
                return new FlatSelectImgOnlyField(attributes);
            case FieldControl.FLAT_IMAGE_GALLERY:
                return new FlatImageGalleryField (attributes);
            case FieldControl.POPUP_FLAT_SELECT_IMG_ONLY:
                attributes['withImages'] = true;
                return new FlatSelectImgOnlyField(attributes);
            case FieldControl.FLAT_SELECT_IMG_AND_TEXT_ONLY:
                attributes['withHoverImages'] = true;
                attributes['withImages'] = true;
                return new FlatSelectField(attributes);
            case FieldControl.TEXTBOX:
                return new TextboxField(attributes);
            case FieldControl.TEXTAREA:
                return new TextareaField(attributes);
            case FieldControl.DATE_INPUTS:
            case FieldControl.DATE_PICKER:
            case FieldControl.DATE_INPUT_INLINE_TITLE:
                return new DateField(attributes);
            case FieldControl.RADIO_BUTTON:
                return new RadioButtonField(attributes);
            case FieldControl.CURRENCY_ILS:
                attributes['currency'] = 'ILS';
                return new CurrencyField(attributes);
            case FieldControl.CURRENCY_USD:
                attributes['currency'] = 'USD';
                return new CurrencyField(attributes);
			case FieldControl.MAIN_SEPARATOR:
				attributes['fieldClass'] = 'main-separator';
				return new SeparatorField(attributes);
			case FieldControl.SUB_SEPARATOR:
				attributes['fieldClass'] = 'sub-separator';
				return new SeparatorField(attributes);
            case FieldControl.SIGNATURE:
                return new SignatureField(attributes);
            case FieldControl.FILE_UPLOAD:
                return new FileUploadField(attributes);
            case FieldControl.GRID:
                return new GridField(attributes);
            case FieldControl.BARCODE:
                return new BarCode(attributes);
            case FieldControl.FLAT_SELECT_IMAGE_ON_CLICK:
                attributes['withImages'] = true;
                attributes['imageOnClick'] = true;
                return new FlatSelectField(attributes);
            case FieldControl.MULTI_SELECT_GROUPS:
                return new MultiSelectGroupsField(attributes);
            case FieldControl.STAR_RATING:
                return new StarRatingField(attributes);
            case FieldControl.CAPTCHA:
                return new CaptchaField(attributes);
            case FieldControl.NUMBER_RATING:
                return new NumberRatingField(attributes);
            case FieldControl.SELECT_SEARCH:
                attributes['searchSelect'] = true;
                return new DropdownField(attributes);
            case FieldControl.MULTI_SELECT_SEARCH:
                attributes['searchSelect'] = true;
                attributes['isMultiple'] = true;
                return new DropdownField(attributes);
            case FieldControl.PERCENTAGE:
				return new PercentageField(attributes);
            case FieldControl.NGX_COMPONENT:
                return new NgxComponentField(attributes);
            case FieldControl.CHECKBOX:
                return new CheckboxField(attributes);
            case FieldControl.SLIDE_TOGGLE:
                return new SlideToggleField(attributes);
			case FieldControl.CONFIRMATION_FIELD:
				return new ConfirmationField(attributes);
            case FieldControl.CARD_VALIDITY:
                return new CardValidity(attributes);
            case FieldControl.PHONE_WITH_PREFIX:
                return new PhoneWithPrefix(attributes);
            case FieldControl.MOBILE_WITH_PREFIX:
                return new PhoneWithPrefix(attributes);
            case FieldControl.USERS_AUTOCOMPLETE:
                return new UsersAutocomplete(attributes);
            case FieldControl.AUTOCOMPLETE:
                return new Autocomplete(attributes);
            case FieldControl.LOOK_UP_DETAIL:
                return new LookUpDetailField(attributes);
            case FieldControl.LOOK_UP:
                return new LookUpField(attributes);
            case FieldControl.USER_LOOK_UP:
                return new UserLookUpField(attributes);
            case FieldControl.USER_LOOK_UP_DETAIL:
                return new UserLookUpDetailField(attributes);
            default:
                return new TextboxField(attributes);
        }
    }


	public static createHiddenField(name, attr: object = {}) {
        let attributes: any = {key: name, isHidden: true, fieldClass: 'd-none-field', updateValuesByOtherAns: true, ...attr}
        let fieldData = name.split(':');
        if (fieldData[1] && fieldData[1] == 'async') {
            attributes.key = fieldData[0];
            attributes.asyncLoading = true;
            attributes.attrForAns = [];
        }
		return this.create(attributes);
	}

}

